import React from "react"
import OtherNavbar from "components/Navbars/OtherNavbar.js"
import Footer from "components/Footers/Footer.js"
import { Container } from "reactstrap"
class PrivacyPolicy extends React.Component {
  render() {
    return (
      <>
        <div>
          <OtherNavbar />
          <div className="main-content mt-4">
            <Container>
              <h1>Privacy Policy</h1>
              <i>Last Revised: January 25, 2021</i>
              <h2 className="mt-4">INTRODUCTION</h2>
              <p>
                Privacy and security of your personal information are very
                important to us. This Privacy Policy describes how we, New Vices
                LLC DBA Faver, a limited liability company governed by the laws
                of the State of California, USA (“<b>Faver</b>,” ”<b>we</b>," “
                <b>our</b>,” or “<b>us</b>”), collect, store, use, and disclose
                personal information (as defined below) of users of the website
                www.needafaver.com and mobile applications associated with it
                (collectively, “<b>Platform</b>”).
              </p>
              <p>
                We aim to limit our collection of personal information to only
                such personal information as required for legitimate purposes.
                We do not sell, rent, trade or otherwise disclose your personal
                information to third parties, other than as described in this
                Privacy Policy. We take appropriate security measures to protect
                your personal information and we respect your right to access
                your personal information or have it corrected or deleted, at
                your request. If you have any questions, or want to know exactly
                what personal information we keep about you, please contact us.
                All capitalized terms not defined herein are defined in our{" "}
                <a href="/terms">Terms of Service</a>.
              </p>
              <p>
                We may amend this Privacy Policy from time to time. We will post
                any changes to this Privacy Policy here so that you always know
                what information we gather, how we might use that information,
                and whether we will disclose that information to anyone. Please
                refer back to this Privacy Policy on a regular basis. By using
                the Platform, you acknowledge that you accept the practices and
                policies outlined in this Privacy Policy and you hereby consent
                that we will collect, store, use, and disclose your personal
                information as outlined in this Privacy Policy. If you do not
                agree with any practices in this Privacy Policy, please stop
                using the Platform.
              </p>
              <h2 className="mt-4">
                PERSONAL INFORMATION COLLECTED THROUGH WEBSITE
              </h2>
              <p>
                “<b>Personal information</b>,” also known as personal data or
                personally identifiable information, is any information related
                to an identifiable person. When you register for an Account or
                place an order, we may collect the following personal
                information from you:{" "}
              </p>
              <ul>
                <li>
                  From Clients: name, email address, phone number, address,
                  username, encrypted password, and any personally identifiable
                  information that Clients provide to us voluntarily.
                </li>
                <li>
                  From Service Providers: entity name, phone number, entity’s
                  physical address, opening and closing hours, areas (zip codes)
                  the entity serves, Service description(s), Service price(s),
                  bank account number, routing number, and any personally
                  identifiable information that Service Providers provide to us
                  voluntarily.
                </li>
              </ul>
              <h2 className="mt-4">
                NON-PERSONAL OR AGGREGATE INFORMATION WE MAY COLLECT
              </h2>
              <p>
                We may collect data which is non-personal, anonymous, or
                pseudonymous, including, but not limited to, time zone you are
                in, information on how you first heard about us, browser type,
                app usage history, number of logins, demographics and
                geographics data, history of our interaction with you, page
                views, and time/date of login.
              </p>
              <h2 className="mt-4">
                PURPOSES FOR WHICH WE USE INFORMATION ABOUT YOU
              </h2>
              <p>
                We only use information about you to support your experience
                throughout the Platform or to communicate with you about
                Services or Service Providers. In particular, we collect
                information about you:
              </p>
              <ul>
                <li>
                  to manage our business relationship with you, for example: to
                  process your orders, recognize you as our client, respond to
                  your inquiries or requests, and provide customer support;
                </li>
                <li>
                  for marketing and advertising purposes, for example, to
                  provide you with information you have requested about our
                  services;
                </li>
                <li>
                  to let you communicate with other users of the Platform via
                  SMS service (this means that other Platform users, with who
                  you form a Service Agreement, will have access to your phone
                  number);
                </li>
                <li>to conduct market research; </li>
                <li>
                  to allow our vendors (including payment processing and email
                  marketing companies) to help us run our business smoothly;
                </li>
                <li>
                  to comply with all applicable laws or if we are required by
                  law or by a court order to do so;
                </li>
                <li>
                  to analyze non-personal or aggregate information for the sake
                  of Platform improvement;
                </li>
                <li>
                  to transfer information in connection with the sale or merger
                  or change of control of Faver; or
                </li>
                <li>update, administer, and maintain our Platform.</li>
              </ul>
              <p>
                We reserve the right to use and disclose non-personal
                information and anonymous aggregate statistics for any purpose
                and to any third party at our sole discretion.
              </p>
              <h2 className="mt-4">SOCIAL LOGINS</h2>
              <p>
                Social login is a form of single sign-on using existing
                information from a social media service such as Facebook,
                Twitter, Instagram or Google, to sign in and register on a third
                party website. We offer you an option to register and sign in on
                our Platform using your social media accounts from Facebook and
                Google. If you choose to register and sign in on our Platform
                using any of your social media accounts, we may have access to
                certain information about you. The profile Information we
                receive may vary depending on the social media service
                concerned, but will often include your name, e-mail address,
                friends list, profile picture as well as other information you
                choose to make public. We will use the information we receive
                only for the purposes that are described in this Privacy Policy.
                Please note that we do not control, and are not responsible for,
                other uses of your personal information by your third party
                social media services. These social media services may collect
                your personal information and monitor your activity on the
                Platform. Please refer to their respective privacy policies to
                learn more about their data collection, storage and usage
                policies.
              </p>
              <h2 className="mt-4">BUSINESS TRANSFERS</h2>
              <p>
                We may sell, transfer or otherwise share some or all of our
                assets, including your personal information, in connection with
                a merger, acquisition, reorganization, bankruptcy, or sale of
                assets.
              </p>
              <h2 className="mt-4">
                YOUR FINANCIAL INFORMATION &amp; PAYMENT PROCESSING
              </h2>
              <p>
                Stripe is our trusted vendor, which processes payments on our
                behalf. When you book a Service, we will store your financial
                information and process your payment(s) via Stripe’s service.
                Stripe adheres to the standards set by PCI-DSS as managed by the
                PCI Security Standards Council, which is a joint effort of
                brands like Visa, MasterCard, American Express and Discover.
                PCI-DSS requirements help ensure the secure handling of any
                payment information.
              </p>
              <h2 className="mt-4">FEEDBACK &amp; REVIEWS</h2>
              <p>
                If you submit any feedback/review (about a Service or Faver) or
                if you rate a Service (collectively, “<b>Review”</b>), you
                hereby assign to Faver all rights in the Review and agree that
                Faver shall have the right to use such Review and related
                information in any manner it deems appropriate. We will treat
                any Review you provide to us as non-confidential and
                non-proprietary. You agree that you will not submit to us any
                information or ideas that you consider to be confidential or
                proprietary.
              </p>
              <h2 className="mt-4">COOKIES POLICY</h2>
              <p>
                This Cookie Policy provides information about our use of cookies
                in connection with your use of and interaction with our
                Platform.{" "}
              </p>
              <p>
                A “cookie” is a small piece of data sent along with pages of a
                website and stored by the user's web browser on the user's
                computer or mobile device. Cookies were designed to be a
                reliable mechanism for websites to remember certain information
                (such as items added in a shopping cart) or to record a user's
                browsing activity (including clicking particular buttons,
                logging in, or recording which pages were visited in the past).
                Cookies are intended to help you access a website faster and
                more efficiently, because they can store information to help you
                enter a website without having to log in. In effect, cookies
                tell the website that your browser has been to the website
                before. It does not need to know your exact identity. Cookies
                can also be used to remember arbitrary pieces of information
                that the user previously entered into form fields such as names,
                addresses, passwords, and credit card numbers.
              </p>
              <p>
                Browsers may accept or reject cookies automatically but allow
                you to change these settings. The help menu on most browsers
                will tell you how to change your browser’s settings and how to
                have the browser notify you when you receive a new cookie, and
                how to disable cookies all together. You can also disable or
                delete cookies you have previously accepted if you wish to.{" "}
              </p>
              <p>
                Like many other websites, we also use cookies on our Platform.
                By using the Platform, you agree that we may set cookies listed
                below. These cookies ensure that certain parts of the Platform
                work properly and that your user preferences remain known. You
                do have the right to opt-out and to object against the further
                use of any cookies. However if you do so, please keep in mind
                that our Platform may no longer function properly for you.
              </p>
              <p>
                The following are examples of cookies that may be used on our
                Platform:
              </p>
              <ol>
                <li>
                  <b>Strictly necessary cookies.</b> These cookies are essential
                  in order to enable you to move around the Platform and use its
                  features. Without these cookies, Services you are interested
                  in may not be booked.{" "}
                </li>
                <li>
                  <b>Performance/analytic cookies.</b> These cookies collect
                  data about how visitors use our Platform, including the
                  country from which the visitor is accessing the Platform. They
                  allow us to recognize and count the number of visitors and to
                  see how visitors move around the Platform when they are using
                  it.{" "}
                </li>
                <li>
                  <b>Functionality cookies.</b> These are used to recognize you
                  when you return to our Platform. This enables us to
                  personalize our content for you, greet you by name and
                  remember your preferences (for example, your choice of
                  language or region).
                </li>
              </ol>
              <h2 className="mt-4">MINORS (CHILDREN) POLICY</h2>
              <p>
                We are committed to protecting children's personal information
                and comply with the strictest privacy laws out there. We do not
                knowingly collect or solicit personal information from anyone
                under the age of majority. If you are a minor, please do not
                send any information about yourself to us, including your name,
                address, telephone number, or email address. In the event that
                we learn that we have collected personal information from a
                minor, we will delete that information as quickly as possible.
                Please contact us if you believe we may have collected
                information from a minor.
              </p>
              <h2 className="mt-4">HOW LONG WE KEEP YOUR INFORMATION</h2>
              <p>
                We will only keep your personal information for as long as it is
                necessary for the purposes set out in this Privacy Policy,
                unless a longer retention period is required or permitted by law
                (such as tax, accounting or other legal requirements) or up
                until such time when you withdraw your consent for processing
                it. When we have no ongoing legitimate business need to process
                your personal information, we will either delete or anonymize
                it, or, if this is not possible (for example, because your
                personal information has been stored in backup archives), then
                we will securely store your personal information and isolate it
                from any further processing until deletion is possible.
              </p>
              <h2 className="mt-4">DATA STORAGE</h2>
              <p>
                We use Google Cloud Platform service to safely store your
                information. The data centers where we store your information
                are located in the United States. Please keep in mind that the
                data protection and privacy laws of the United States may not be
                as comprehensive as the laws in your country. For example,
                personal data transferred to the United States may be subject to
                lawful access requests by federal and state authorities in the
                United States. By providing your personal information, you
                consent to any transfer of your data and processing in
                accordance with this Privacy Policy.
              </p>
              <h2 className="mt-4">SECURITY</h2>
              <p>
                The security of your information is very important to us. We
                apply all reasonable security measures and comply with the
                industry standards to protect your personal information
                (including, preventing the loss, misuse, unauthorized access,
                disclosure, alteration and destruction of your personal
                information). Notably, access to the Platform’s database with
                your personal information is held behind administrative logins
                and managed, controlled and limited to authorized website
                administrators and support technicians only. Data transmitted
                between browser and application servers is encrypted using an
                HTTPS/SSL certificate. We do not collect or store your
                passwords. We use XSRF against cross-domain attacks. Data is
                backed up daily. The Platform’s server software is updated
                regularly to ensure we are running the latest and safest
                software (where applicable and depending on compatibility). The
                server's firewall is configured to prevent unauthorized access,
                and activity is automatically monitored to detect and ban
                malicious activity.
              </p>
              <p>
                Please be aware, however, that despite our efforts, no security
                measures are impenetrable. No method of transmission over the
                Internet, or method of electronic storage, is 100% secure. Thus,
                while we strive to protect your personal information, we cannot
                ensure and do not warrant the security of any information you
                transmit to us.
              </p>
              <h2 className="mt-4">
                MARKETING EMAILS, OTHER COMMUNICATIONS &amp; OPT-OUT OPTION
              </h2>
              <p>
                With your consent you will receive updates, newsletters,
                surveys, offers, ads and other promotional materials from us via
                your email. You may indicate a preference to stop receiving
                further communications or notifications from us by following the
                unsubscribe link provided in the email you receive. Despite your
                indicated preferences, we may send you service related
                communication, including notices of any updates to Platform’s
                Terms of Service, Privacy Policy, or other statements.
              </p>
              <h2 className="mt-4">CONTACT US</h2>
              <p>
                If you would like to exercise any of the above rights or learn
                more about this Privacy Policy, please contact us.
              </p>
              <p>
                <b>Email:</b> contact@needafaver.com
                <br />
                <b>Mailing Address:</b> 11858 Goshen Ave., Apt 101 Los Angeles,
                CA 90049
                <br />
                <b>Phone:</b> 206-399-9179
              </p>
            </Container>
          </div>
          <Footer />
        </div>
      </>
    )
  }
}

export default PrivacyPolicy
